import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolAction } from '../symbol.action';

export const startSymbolProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolAction.create.started,
    SymbolAction.update.started,
    SymbolAction.remove.started,
  ),
  mergeMap(() => {
    return [
      SymbolAction.processing.started(),
    ];
  }),
);
